import { Accordion, theme } from '@evgo/react-material-components';
import styled from 'styled-components';
import config from '../../../../config';

const { spacing } = theme;
const { colors } = config;

export const Styled = styled(Accordion)`
  section {
    box-sizing: border-box;
    width: calc(100% - 32px);
    margin: 32px 16px 0px;
    header {
      padding: ${`0 ${spacing(3)}px`};
    }
  }
  div {
    &.container {
      display: flex;
      flex: 1 1 100%;

      .controls {
        display: flex;
        align-items: center;
        margin-left: auto;
        padding-right: 20px;
      }
    }

    &.host-contacts-list {
      max-height: 534px;
      overflow: auto;
    }
  }

  .host-contacts-list {
    padding: 0;
  }

  h2 {
    color: ${colors.accentBlue};
  }

  table {
    td,
    th {
      padding: ${`${spacing(2)}px ${spacing()}px`};

      &:first-child {
        padding-left: ${spacing(3)}px;
      }

      &:last-child {
        padding-right: ${spacing(3)}px;
      }
    }

    td {
      position: relative;
    }
  }
`;
